import {Injectable} from '@angular/core';
import {I18NextPipe} from 'angular-i18next';
import {I18nextFormattersService} from 'app/core/services/i18next-formatters.service';
import {KnownMeasure} from 'app/features/analytics/features/reports/dimension';
import {Measure} from 'app/features/analytics/service/dimensions-and-measures.interfaces';
import {DimensionsAndMeasuresService} from 'app/features/analytics/service/dimensions-and-measures.service';

export interface Metric {
    id: KnownMeasure | string;
    group?: string;
    title: string;
    formatCompact?: (v: any) => string;
    format?: (v: any) => string;
    isForecast?: boolean;
    helpHTML: string;
    subGroup?: string;
    subGroupName?: string;
}

@Injectable()
export class MeasuresService {
    map: Record<KnownMeasure, Metric>;

    helpKey(m: Pick<Measure, 'id'>) {
        return `analytics.docs.measures.meaningful.${m.id}`;
    }

    constructor(
        private i18next: I18NextPipe,
        private formatter: I18nextFormattersService,
        private dms: DimensionsAndMeasuresService
    ) {
        this.map = this.buildMapKnownMeasure(
            this.dms.available.measureList
                .map(m => ({
                    id: m.id,
                    title: m.label,
                    helpHTML: this.i18next.transform(this.helpKey(m)),
                }))
                .filter(v => v.helpHTML !== this.helpKey(v))
        );
    }

    buildMapKnownMeasure(knownMeasures: Metric[]): Record<KnownMeasure, Metric> {
        return knownMeasures.reduce(
            (acc, m) => {
                acc[m.id] = m;
                return acc;
            },
            {} as Record<KnownMeasure, Metric>
        );
    }
}
